/**
 * @see https://gitlab.cego.dk/spilnu/spilnu-dk/-/blob/master/website/app/Lib/ErrorCodes/ErrorCodes.php?ref_type=heads
 */
export enum MonolithErrorCode {
    /**
     * General error codes
     * range: 0000 - 0999
     */
    GENERAL_ERROR = 'MO:0001',
    BAD_REQUEST = 'MO:0400',
    METHOD_NOT_ALLOWED = 'MO:0405',
    TOO_MANY_REQUESTS = 'MO:0429',
    REQUIRE_AJAX = 'MO:0010',
    /**
     * Player Team error codes
     * range: 1000 - 1999
     */
    WRONG_USERNAME_OR_PASSWORD = 'MO:1101',
    COUNTRY_BLOCKED = 'MO:1110',
    EXCLUDED_IN_GAMBLING_AUTHORITY = 'MO:1111'
}

export enum UserAuthErrorCode {
    /**
     * User Auth service error codes
     */
    INTERNAL_ERROR = 'UA:1000',
    USER_DOES_NOT_EXIST = 'UA:1100',
    OUTSIDE_GEOFENCE = 'UA:1200',
    USER_EXCLUDED_GAMBLING_AUTHORITY = 'UA:1300',
    MITID_SSN_MISMATCH = 'UA:1400',
    INVALID_EMAIL_OR_PASSWORD = 'UA:1500',
    RATE_LIMIT_EXCEEDED = 'UA:1600',
    USER_MUST_REACTIVATE = 'UA:1700',
    REACTIVATION_FAILED_DUE_TO_BEING_SUSPENDED = 'UA:1800',
    TURNSTILE_CANNOT_BE_VERIFIED = 'UA:1900',
    MAGIC_LINK = 'UA:2000',
    REACTIVATION_FAILED_DUE_TO_GAMBLING_EXCLUSION = 'UA:2100',
    PASSWORD_RESET_INVALID_TOKEN = 'UA:3000',
    PASSWORD_RESET_OUTSIDE_GEOFENCE = 'UA:3200',
    PASSWORD_RESET_RATE_LIMITED = 'UA:3300',
}

export const ErrorCode = {
    MONOLITH: MonolithErrorCode,
    USER_AUTH: UserAuthErrorCode
}
